import { HeaderPrintListProps } from "./AddHeaderSapiensPrintList";
import { generateHeaderPdf, getHeaderStaticPdf, mergedPdfHeader } from "./StaticPdfUtils";

// PDF Path
const PDF = "static/pdf/printList/cons_pdpa_en.pdf";
const FORM_NAME = "Consent to Disclose Personal Health Information in Electronic Format";

const FormConsentPDPAEN = async (props: any) => {
  try {
    const pdfPath = props.items?.headerInfo?.file_path ?? PDF;
    const existingPdfBytes = await fetch(pdfPath).then((res) => res.arrayBuffer());
    const pdfBytes = new Uint8Array(existingPdfBytes);

    const headerConfigList: HeaderPrintListProps[] = [
      // Page 1
      { headerMargins: [12, 10, 13, 0], freeLine: 0, extraCanvasHeight: 2 },
      // Page 2
      { headerMargins: [12, 10, 13, 0], freeLine: 0, extraCanvasHeight: 2 }
    ];

    const headerDefs = await Promise.all(
      headerConfigList.map((config) => 
        getHeaderStaticPdf(
          {
            formName: props.items?.headerInfo?.name || FORM_NAME,
            patientInfo: props.items,
            detail: props.detail,
            ...config,
          },
          "mini"
        ),
      ),
    );

    const headerPdfBytesList = await Promise.all(headerDefs.map((def) => generateHeaderPdf(def)));
    const mergedPdfBytes = await mergedPdfHeader(pdfBytes, headerPdfBytesList);

    const blob = new Blob([mergedPdfBytes as BlobPart], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    return {
      uint8Array: mergedPdfBytes,
      blobUrl,
      blobRaw: blob,
      base64String: Buffer.from(mergedPdfBytes).toString("base64"),
    };
  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormConsentPDPAEN;